export default __webpack_public_path__ + "static/media/37.f687b96f.png";